import React from "react";
import { FaPhoneAlt } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const TopNav = () => {
  const navigate = useNavigate();
  return (
    <div className="w-full tracking-wide bg-gradient-to-r from-[#001A2C] to-[#003366] text-white hidden md:block">
      <div className="px-4 lg:px-12 py-2 flex flex-col sm:flex-row justify-between items-center">
        <div className="flex items-center space-x-4">
          <div className="flex items-center space-x-2 text-sm">
            <FaPhoneAlt />
            <span>+91 9337233933, +91 7326979740, +91 9583146761</span>
          </div>
        </div>

        <div className="flex items-center space-x-4 text-sm">
          <p
            onClick={() => navigate("/consultant-enquiries")}
            className="cursor-pointer hover:text-orange-300 transition-colors duration-200"
          >
            Consultant Registration Form
          </p>
        </div>
      </div>
    </div>
  );
};

export default TopNav;
